{
	"content": {
		"title": "Επιλέξτε τα υλικά που απαιτούν δηλώσεις",
		"materialListLabel": "Υλικό",
		"materialQuantityLabel": "Ποσότητα υλικού ({{unit}})",
		"availableQuantityLabel": "Διαθέσιμη ποσότητα ({{unit}})",
		"carbonSavingsLabel": "Μειώσεις άνθρακα ({{unit}} ισοδύναμο CO₂)"
	},
	"summary": {
		"title": "Περίληψη",
		"declarationTypeTitle": "Τύπος δήλωσης",
		"customerProjectTitle": "Έργο πελάτη",
		"internalProjectOrProductTitle": "Εσωτερικό έργο / προϊόν",
		"projectReferenceTitle": "Αναφορά έργου",
		"materialHeaderTitle": "Υλικό",
		"quantityHeaderTitle": "Ποσότητα ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Κατανεμόμενες μειώσεις άνθρακα ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Μη κατανεμόμενη μείωση άνθρακα ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Απαιτείται ποσότητα",
		"quantityPositive": "Εισαγάγετε μια θετική ποσότητα.",
		"quantityLargerThanAvailable": "Μειώστε την ποσότητα στο σύνολο των διαθέσιμων",
		"savingsRequired": "Απαιτούνται μειώσεις άνθρακα",
		"fetchNotTransferedMaterialsError": "Αποτυχία λήψης μη μεταφερθέντων υλικών"
	},
	"submitTitle": "Προσθήκη στο έργο",
	"backTitle": "Πίσω"
}
